import _ from 'lodash'

export const ua = navigator.userAgent
// 微信H5环境
export const wechatEnvironment = /micromessenger/.test(ua.toLowerCase())
// 支付宝环境
export const alipayClient = /AlipayClient/.test(window.navigator.userAgent)
// 微信小程序
export const wxMiniprogram = window.__wxjs_environment === 'miniprogram'

// ios operate system
export function inIos () {
  return /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(ua)
}

export function isInWxMP () {
  return Boolean((navigator.userAgent.match(/micromessenger/i) && navigator.userAgent.match(/miniprogram/i)) || window.__wxjs_environment === 'miniprogram');
}

export function isInAliMP () {
  return navigator.userAgent.toLowerCase().includes('aliapp');
}

export function isInTtMP () {
  return navigator.userAgent.toLowerCase().includes("toutiaomicroapp");
}

// iphonex
export function longScreen () {
  let { width, height } = window.screen
  return height / width > 1.9
}

// get sessionStorage data
export function getSessionStorage (name, noParse) {
  let data = sessionStorage.getItem(name)
  if (noParse || !data) return data
  return JSON.parse(data)
}

// set localStorage data
export function setLocalStorage (name, data, expireTime) {
  if (!name) throw new Error('need name')
  let needStringify = typeof data === 'object'
  let storageData = {
    expireTimeStamp: '',
    value: needStringify ? JSON.stringify(data) : data,
    stringified: needStringify ? '1' : '0'
  }
  if (expireTime) {
    storageData.expireTimeStamp = expireTime
  }
  return localStorage.setItem(name, JSON.stringify(storageData))
}

// get localStorage data,
export function getLocalStorage (name) {
  let data = localStorage.getItem(name)
  if (!data) return null
  data = JSON.parse(data)
  if (data.expireTimeStamp && new Date().getTime() > Number(data.expireTimeStamp)) {
    removeLocalStorage(name)
    return null
  }
  return data.stringified === '1' ? JSON.parse(data.value) : data.value
}

export function removeLocalStorage (name) {
  if (!name) return
  localStorage.removeItem(name)
}

// set sessionStorage data
export function setSessionStorage (name, data) {
  if (!name) throw new Error('need name')
  let needStringify = typeof data === 'object'
  let storageData = needStringify ? JSON.stringify(data) : data
  return sessionStorage.setItem(name, storageData)
}

/*
** randomWord 产生任意长度随机字母数字组合
** randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
*/
export function randomWord (randomFlag, min, max) {
  let str = ''
  let range = min
  let arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min
  }
  for (let i = 0; i < range; i++) {
    let pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}

function getUserAgent () {
  return window.navigator.userAgent.toLowerCase()
}

// 获取微信版本号
export function getWeixinVersion () {
  if (wechatEnvironment) {
    let wechatInfo = getUserAgent().match(/micromessenger\/([\d.]+)/i)
    return !_.isEmpty(wechatInfo) && wechatInfo[1]
  }
  return false
}
// 获取ios大版本号
export function getIosFirstVersion () {
  let ua = getUserAgent()
  let version = ua.match(/cpu iphone os (\d+)(_*\d*)* like mac os/)
  if (!version) return false
  return Number(version[1])
}

// 获取本地时间的时间戳
export function getTimestamp (unit) {
  let date = new Date()
  let divisor = 1000
  switch (unit) {
  case 'h': {
    divisor = 3600000
    break
  }
  case 'm': {
    divisor = 60000
    break
  }
  case 'd': {
    divisor = 86400000
    break
  }
  case 's': break
  }
  return Math.floor(date / divisor)
}
// 判断手机平台类型
export function getPlatForm () {
  let type = ''
  if (/android/i.test(ua)) {
    type = 'android'
  }
  if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
    type = 'ios'
  }
  return type
}

// 设置cookie
export function setCookie (cookieName, value, expiredays) {
  let exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = cookieName + '=' + encodeURIComponent(value) + (!expiredays ? '' : ';expires=' + exdate.toGMTString())
}
// 获取cookie
export function getCookie (name) {
  let arr
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  arr = document.cookie.match(reg)
  return arr ? arr[2] : null
}
// 删除cookie
export function delCookie (name) {
  let exp = new Date()
  exp.setTime(exp.getTime() - 1)
  let cval = getCookie(name)
  if (cval) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  }
}
// 获取当前地址
export function getCurrentURLPath () {
  return window.location.host + window.location.pathname
}
// 保存当前hash路径
export function sotrageHashPath (hash) {
  let hashPath = hash || window.location.hash
  setCookie('hash-path', hashPath)
}
// 移除保存的hash路径
export function removeHashPath () {
  delCookie('hash-path')
}
// 判断当前时间是否为北京标准时间
export function isBeijingTimezone () {
  let localTime = new Date()
  return localTime.getTimezoneOffset() === -480
}
// 获取微信小版本号(最后一位)
function getWeixinChildVersion () {
  let version = getWeixinVersion()
  if (version) {
    let matchd = version.match(/([^.])$/)
    if (matchd) {
      return Number(matchd[1])
    }
  }
  return false
}
// 获取微信主版本号(前两位)
function getWeixinMainVersion () {
  let version = getWeixinVersion()
  if (version) {
    let matchd = version.match(/(\d(\.\d)?).*/)
    if (matchd) {
      return Number(matchd[1])
    }
  }
  return false
}
// 检测当前环境是否是微信输入框有bug的版本: 版本：ios12以上 wechat6.7.4以上
export function isWeixinKeybordBugVersion () {
  if (!wechatEnvironment) return false
  // wechat6.7.4以上
  if (getWeixinMainVersion() < 6.7) return false
  if (getWeixinMainVersion() === 6.7 && getWeixinChildVersion() < 4) return false

  // ios12以上
  let iosVersion = getIosFirstVersion()
  if (!iosVersion || iosVersion < 12) return false
  return true
}
/**
  * 解决虚拟键盘弹出导致页面被顶起，键盘隐藏页面却不回落的问题
  * 版本：ios12以上 wechat6.7.4以上
  */
export function solveIosKeybordBug () {
  if (isWeixinKeybordBugVersion()) {
    // 全局监听input元素的blur事件
    document.addEventListener('focusout', () => {
      // scrollTo使页面回归正常位置,setTimeout使dom操作异步，提高页面的流畅程度
      setTimeout(() => {
        let height = document.documentElement.scrollTop || document.body.scrollTop
        window.scrollTo(0, height + 1)
        window.scrollTo(0, height - 1)
      }, 17)
    })
  }
}
// 修改页面title
export function changeTitle (title) {
  if (!title || typeof title !== 'string') return
  // 修改页面title
  document.title = title
  // 通过iframe修改title描述(兼容低版本微信)
  let hackIframe = document.createElement('iframe')
  hackIframe.style.display = 'none'
  document.body.appendChild(hackIframe)
  document.body.removeChild(hackIframe)
}
// 根据经纬度计算两点间的距离
export function getFlatternDistance (lat1, lng1, lat2, lng2) {
  const EARTH_RADIUS = 6378137.0 // 单位M
  const PI = Math.PI
  function getRad (d) {
    return d * PI / 180.0
  }

  let f = getRad((lat1 + lat2) / 2)
  let g = getRad((lat1 - lat2) / 2)
  let l = getRad((lng1 - lng2) / 2)

  let sg = Math.sin(g)
  let sl = Math.sin(l)
  let sf = Math.sin(f)

  let s, c, w, r, d, h1, h2
  let a = EARTH_RADIUS
  let fl = 1 / 298.257

  sg = sg * sg
  sl = sl * sl
  sf = sf * sf

  s = sg * (1 - sl) + (1 - sf) * sl
  c = (1 - sg) * (1 - sl) + sf * sl

  w = Math.atan(Math.sqrt(s / c))
  r = Math.sqrt(s * c) / w
  d = 2 * w * a
  h1 = (3 * r - 1) / 2 / c
  h2 = (3 * r + 1) / 2 / s

  return d * (1 + fl * (h1 * sf * (1 - sg) - h2 * (1 - sf) * sg))
}

/**
 * @description obj 转 arr
 */
export function objToArr (obj, keyName = 'code', valueName = 'label') {
  if (_.isEmpty(obj)) return []
  let res = []
  let keys = _.keys(obj)
  let values = _.values(obj)
  keys.forEach((key, index) => {
    let item = {
      [keyName]: key,
      [valueName]: values[index]
    }
    res.push(item)
  })
  return res
}

/**
 * @description 判断字符串或数字为空，可以为0
 * @param {String, Number} value
 */
export function isBlank (value) {
  try {
    const _value = value.toString()
    return !_value
  } catch (error) {
    return true
  }
}

/**
 * @description 清除Object中空项
 * @param {Object} obj
 */
export function clearBlankItem (obj) {
  const res = { ...obj }
  for (let k in res) {
    const value = res[k]
    if (isBlank(value)) delete res[k]
  }
  return res
}

/**
 * toFied 四舍五入，消除精度丢失
 * @param {*} number
 * @param {Number} point
 */
export function toFixed (number, point) {
  let numArr = Number(number).toFixed(point + 1).split('.')
  // 判断个位大于等于5，加1
  if (numArr.length > 1 && Number(numArr[1]) % 10 >= 5) numArr[1] = Number(numArr[1]) + 1
  return Number(numArr.join('.')).toFixed(point)
}

export function cloudImgToCompress (path) {
  return path.replace(process.env.VUE_APP_QINIU_DIR_NAME, '/compress/')
}

// canvas绘制竖版文字
CanvasRenderingContext2D.prototype.fillTextVertical = function (text, x, y) {
  let context = this;

  let arrText = text.split('');
  let arrWidth = arrText.map(function (letter) {
    return context.measureText(letter).width;
  });

  let align = context.textAlign;
  let baseline = context.textBaseline;

  if (align === 'left') {
    x = x + Math.max.apply(null, arrWidth) / 2;
  } else if (align === 'right') {
    x = x - Math.max.apply(null, arrWidth) / 2;
  }
  if (['bottom', 'alphabetic', 'ideographic'].includes(baseline)) {
    y = y - arrWidth[0] / 2;
  } else if (['top', 'hanging'].includes(baseline)) {
    y = y + arrWidth[0] / 2;
  }

  context.textAlign = 'center';
  context.textBaseline = 'middle';

  // 开始逐字绘制
  arrText.forEach(function (letter, index) {
    // 确定下一个字符的纵坐标位置
    let letterWidth = arrWidth[index];
    // 是否需要旋转判断
    let code = letter.charCodeAt(0);
    if (code <= 256) {
      context.translate(x, y);
      // 英文字符，旋转90°
      context.rotate(90 * Math.PI / 180);
      context.translate(-x, -y);
    } else if (index > 0 && text.charCodeAt(index - 1) < 256) {
      // y修正
      y = y + arrWidth[index - 1] / 2;
    }
    context.fillText(letter, x, y);
    // 旋转坐标系还原成初始态
    context.setTransform(1, 0, 0, 1, 0, 0);
    // 确定下一个字符的纵坐标位置
    letterWidth = arrWidth[index];
    y = y + letterWidth;
  });
  // 水平垂直对齐方式还原
  context.textAlign = align;
  context.textBaseline = baseline;
}

// webview 地址参数处理
export function encodeUrlSymbol(url) {
  return url.replace(/\?/g, '!').replace(/&/g, '._~').replace(/#/g, '-._').replace(/=/g, '-.~')
}
